module.exports = __webpack_public_path__ + "img/topbg.87dd712d.png";